import { Component, input, OnInit } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { EmrListComponent } from "../../../../shared/emr-list/emr-list.component";
import { GenitourinaryAssessment } from 'src/app/calvin-emr-shared/models/assessments/genitourinary.model';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { BooleanToYesNoPipe } from 'src/app/shared/utils/boolean-to-yes-no.pipe';

@Component({
  selector: 'app-genitourinary-info',
  templateUrl: './genitourinary-info.component.html',
  styleUrls: ['./genitourinary-info.component.scss'],
  standalone: true,
  imports: [
    AssessmentRowComponent,
    EmrListComponent,
    BooleanToYesNoPipe,
  ],
})
export class GenitourinaryInfoComponent
  extends AssessmentInfoComponent<GenitourinaryAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  constructor() {
    super();
  }

  ngOnInit(): void { }
}
